import {
  ModifyChannelMembershipNodeData,
  ModifyMessageTypeMembershipNodeData,
  NodeClass,
} from 'modules/workflows';
import { WORKFLOW_ACTIONS } from 'modules/workflows/constants';
import { INFO_MESSAGES, modifySubscriptionText } from './ModifySubscriptionEditor.constants';

/**
 * Get comparable values from a given ModifySubscriptionEditor nodeData object.
 * - Only returns fields that are affected by UI changes
 *
 * TODO: update params type once `ModifySubscriptionEditor` is converted to TS
 *
 * @param { Object } data
 * @returns comparable nodeData object
 */
export const getModifySubscriptionEditorNodeDataToBeCompared = (data: Record<string, any>) => ({
  channelId: data?.channelId ?? undefined,
  resource: { name: data?.resource?.name ?? undefined },
  subscribed: data?.subscribed ?? undefined,
});

// returns null or the id to the update function
export const parseSub = (type: string, sub: string[] = []) => {
  const { channel, type: messageType } = modifySubscriptionText;
  const subscription = sub?.[0] ?? '';
  if (subscription?.includes(messageType) && type === messageType) {
    const vals = subscription.split('-');
    return parseInt(vals[0], 10);
  } else if (subscription?.includes(channel) && type === channel) {
    const vals = subscription.split('-');
    return parseInt(vals[0], 10);
  }
  return null;
};

export const isModifyMessageTypeAction = (nodeClass: NodeClass) =>
  nodeClass === WORKFLOW_ACTIONS.MODIFY_MESSAGE_TYPE;

export const getDefaultSub = (
  nodeData: ModifyChannelMembershipNodeData | ModifyMessageTypeMembershipNodeData,
) => {
  if (isModifyMessageTypeAction(nodeData?.nodeClass)) {
    return nodeData?.messageTypeId
      ? [`${nodeData.messageTypeId}-${modifySubscriptionText.type}`]
      : [];
  }
  return nodeData?.channelId ? [`${nodeData.channelId}-${modifySubscriptionText.channel}`] : [];
};

export const getClonedField = (nodeClass: NodeClass) =>
  isModifyMessageTypeAction(nodeClass) ? 'messageTypeId' : 'channelId';

export const getInfoMessage = (isSubscribed = true, nodeClass?: NodeClass) => {
  if (isSubscribed) {
    // Subscribe to channel
    if (nodeClass === WORKFLOW_ACTIONS.MODIFY_CHANNEL_SUBSCRIPTION) {
      return INFO_MESSAGES.SUBSCRIBE_TO_CHANNEL;
    }
    // Subscribe to message type
    if (nodeClass === WORKFLOW_ACTIONS.MODIFY_MESSAGE_TYPE) {
      return INFO_MESSAGES.SUBSCRIBE_TO_MESSAGE_TYPE;
    }
  } else {
    // Unsubscribe from channel
    if (nodeClass === WORKFLOW_ACTIONS.MODIFY_CHANNEL_SUBSCRIPTION) {
      return INFO_MESSAGES.UNSUBSCRIBE_FROM_CHANNEL;
    }
    // Unsubscribe from message type
    if (nodeClass === WORKFLOW_ACTIONS.MODIFY_MESSAGE_TYPE) {
      return INFO_MESSAGES.UNSUBSCRIBE_FROM_MESSAGE_TYPE;
    }
  }

  return '';
};
